(function (angular) {
  var serviceId = "conversionService";

  angular
    .module("app")
    .factory(serviceId, ["_", function (_) {
      var NUM_INCHES_IN_METER = 39.370;
      var NUM_POUNDS_IN_KILOGRAM = 2.20462;
      var NUM_INCHES_IN_FOOT = 12;

      function feetToString(wholeFeet) {
        var feet = feet(wholeFeet);
        var inches = inches(wholeFeet);
        var retval = feet + "'" + inches + '"';
        return retval;
      }

      function feet(wholeFeet) {
        var feet = Math.floor(wholeFeet);
        return feet;
      }

      function inches(wholeFeet) {
        var feet = Math.floor(wholeFeet);
        var inches = Math.round((wholeFeet - feet) * 12);
        return inches;
      }

      function round(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
      }

      function feetInchesToMeters(feet, inches, decimals) {
        var totalInches = (NUM_INCHES_IN_FOOT * feet) + inches;

        var meters = totalInches / NUM_INCHES_IN_METER;

        if (decimals) {
          return round(meters, decimals);
        }

        return meters;
      }

      function metersToFeetInches(meters, decimals) {
        var inches = parseInt(meters * NUM_INCHES_IN_METER);
        return [parseInt(inches / NUM_INCHES_IN_FOOT), inches % NUM_INCHES_IN_FOOT];
      }



      function stringToFeetInches(str) {
        var nums = str.match(/\d+/g);
        if ((nums === null) || (nums === undefined)) {
          nums = ["0", "0"];
        }
        if (nums.length < 2) {
          if (str.indexOf("\"")) {
            nums.unshift("0");
          } else {
            nums.push("0");
          }
        }
        return [parseInt(nums[0]), parseInt(nums[1])];
      }

      function stringToTotalInches(str) {
        var feetInches = stringToFeetInches(str);
        var feet = feetInches[0];
        var inches = feetInches[1];

        return (feet * NUM_INCHES_IN_FOOT) + inches;
      }

      function totalInchesToString(totalInches, keepTotalInches) {
        if (keepTotalInches === true) {
          return totalInches.toString() + "\"";
        }

        var feet = Math.floor(totalInches / NUM_INCHES_IN_FOOT);
        var inches = totalInches % NUM_INCHES_IN_FOOT;

        var feetInches = [feet, inches];

        return feetInchesToString(feetInches);
      }

      function feetInchesToString(arr) {
        var feet = arr[0];
        var inches = arr[1];

        if (feet !== "") {
          feet += "'";
        }
        if (inches !== "") {
          inches += "\"";
        }
        return feet + inches;
      }

      function poundsToKilograms(str, decimals) {
        var num;

        if (_.isString(str)) {
          num = parseFloat(str);
        } else if (_.isNumber(str)) {
          num = str;
        }

        var kilograms = num / NUM_POUNDS_IN_KILOGRAM;

        if (decimals) {
          return round(kilograms, decimals);
        }

        return kilograms;
      }

      function kilogramsToPounds(str) {
        return parseInt(parseFloat(str) * NUM_POUNDS_IN_KILOGRAM);
      }

      function inchesToMeters(inch, decimals) {
        var m = parseFloat(inch) / NUM_INCHES_IN_METER;

        return (decimals) ? round(m, decimals) : m;
      }

      function metersToInches(meter) {
        return parseInt(parseFloat(meter) * NUM_INCHES_IN_METER);
      }

      function bounds(min, max, value) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
      }

      var service = {
        stringToFeetInches: stringToFeetInches,
        feetInchesToString: feetInchesToString,

        metersToFeetInches: metersToFeetInches,
        feetInchesToMeters: feetInchesToMeters,

        poundsToKilograms: poundsToKilograms,
        kilogramsToPounds: kilogramsToPounds,

        inchesToMeters: inchesToMeters,
        metersToInches: metersToInches,

        totalInchesToString: totalInchesToString,
        stringToTotalInches: stringToTotalInches,
        feetToString: feetToString,
        feet: feet,
        inches: inches,
        round: round,
        bounds: bounds
      };

      return service;
    }]);

})(window.angular);



// WEBPACK FOOTER //
// ./app/alk-common/conversion.service.js